import { defineStore } from 'pinia'

// Zvonce u zaglavlju: licna obavestenja (poruke za oglase, novi pratioci, odobren oglas) i opsta push obavestenja.
// Brojac se osvezava lagano (/count); lista se ucitava tek kad se zvonce otvori.
export const useNotificationStore = defineStore('useNotificationStore', () => {
  const items = ref([])
  const unread = ref(0)
  const loading = ref(false)
  // broj je vec poznat (stigao sa proverom prijave ili iz /count): zvonce ga ne trazi ponovo
  const loaded = ref(false)

  // broj sa servera (provera prijave pri ucitavanju stranice)
  function setUnread(count) {
    unread.value = count
    loaded.value = true
  }

  const call = (path, options = {}) =>
    useNuxtApp().$apiAuth(`/api/customer/notifications${path}`, { use: 'customer', ...options })

  async function fetchCount() {
    try {
      const res = await call('/count')
      unread.value = res?.data?.unread_count ?? 0
      loaded.value = true
    } catch (e) {
      // zvonce je dodatak: greska ne sme da smeta stranici
    }
  }

  async function fetchFeed() {
    loading.value = true

    try {
      const res = await call('')
      items.value = res?.data?.items ?? []
      unread.value = res?.data?.unread_count ?? 0
    } catch (e) {
      items.value = []
    } finally {
      loading.value = false
    }
  }

  // stranica "Obavestenja" u profilu: sva obavestenja po stranicama; padajuca lista (items) se ne dira
  async function fetchHistory(page = 1) {
    try {
      const res = await call(`/all?page=${page}`)
      unread.value = res?.data?.unread_count ?? unread.value
      return res?.data ?? null
    } catch (e) {
      return null
    }
  }

  // lista je otvorena: opsta obavestenja su viđena, lična ostaju dok se ne otvore
  async function markSeen() {
    try {
      const res = await call('/seen', { method: 'POST' })
      unread.value = res?.data?.unread_count ?? unread.value
    } catch (e) {}
  }

  async function markRead(item) {
    if (!item?.unread) return

    item.unread = false

    // opsta obavestenja (p...) nemaju stanje po kupcu: pokriva ih markSeen
    if (item.kind !== 'personal') return

    unread.value = Math.max(0, unread.value - 1)

    try {
      const res = await call(`/${String(item.id).replace(/^n/, '')}/read`, { method: 'POST' })
      unread.value = res?.data?.unread_count ?? unread.value
    } catch (e) {}
  }

  async function readAll() {
    items.value.forEach((item) => { item.unread = false })
    unread.value = 0

    try {
      await call('/read-all', { method: 'POST' })
    } catch (e) {}
  }

  function reset() {
    items.value = []
    unread.value = 0
    loaded.value = false
  }

  return { items, unread, loading, loaded, setUnread, fetchCount, fetchFeed, fetchHistory, markSeen, markRead, readAll, reset }
})
